// @flow
import React, {PureComponent} from 'react'
import {NotificationManager} from 'modules/Common/components/Notification'
import I18n from 'I18n'

import errorCodeHandle from 'modules/Common/utils/errorCodeHandle'
import Modal from '../Modal'
import styles from './AddCompanyModal.module.scss'

import type {CompanyDetail} from 'modules/Admin/types'

export type Props = {
  isShow: boolean,
  handleClose: () => void,
  handleClickButton: Function,
  error?: any
};

type State = {
  companyName: string,
  companyLocation: string,
  step: string,
  temporaryName: string,
  isLoading: boolean
};

const stepConstants = {
  inputForm: 'INPUT FORM',
  success: 'SUCCESS'
}

const I18nLocal = I18n.admin

export class AddCompanyModal extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      companyName: '',
      companyLocation: '',
      step: stepConstants.inputForm,
      temporaryName: '',
      isLoading: false
    }
  }

  afterOpen = () => {}

  handleChangeLoadingState = () => {
    this.setState({isLoading: !this.state.isLoading})
  }

  renderHeader = () => {
    if (this.state.step === stepConstants.inputForm) {
      return <span>{I18nLocal.addCompany}</span>
    } else {
      return null
    }
  }

  handleSaveBtnClicked = () => {
    const detail: {company: CompanyDetail} = {
      company: {
        name: this.state.companyName.replace(/\s/g, ''),
        fullName: this.state.companyName,
        location: this.state.companyLocation,
        shareClients: true
      }
    }
    this.handleChangeLoadingState()
    this.props.handleClickButton(detail, true).then(() => {
      this.handleChangeLoadingState()
      if (!this.props.error) {
        this.setState({
          step: stepConstants.success,
          companyName: '',
          companyLocation: '',
          temporaryName: detail.company.fullName
        })
      } else {
        NotificationManager.error(
          errorCodeHandle(this.props.error.code, this.props.error.message)
        )
      }
    })
  }

  hanldeChange = (value: string, key: string) => {
    let state = {...this.state}
    state[key] = value
    this.setState(state)
  }

  checkIsNotHaveEmptyField = () => {
    let check = true
    Object.keys(this.state).map(key => {
      const value = this.state[key]
      if (value === '' && key !== 'temporaryName') {
        check = false
      }
      return null
    })
    return check
  }

  renderBodyStepInput = () => {
    const checkIsNotHaveEmptyField = this.checkIsNotHaveEmptyField()

    return (
      <div>
        <div className={styles.form}>
          <div className={styles.input}>
            <span>{I18nLocal.companyName}</span>
            <input
              type='text'
              placeholder={I18nLocal.companyName}
              value={this.state.companyName}
              onChange={e => {
                this.hanldeChange(e.target.value, 'companyName')
              }}
            />
          </div>
          <div className={styles.input}>
            <span>{I18nLocal.location}</span>
            <input
              type='text'
              placeholder={I18nLocal.location}
              value={this.state.companyLocation}
              onChange={e => {
                this.hanldeChange(e.target.value, 'companyLocation')
              }}
            />
          </div>
        </div>
        <hr />
        <div className={styles.buttons}>
          <div
            className={`${styles.button} ${styles.red}`}
            onClick={this.props.handleClose}
          >
            {I18nLocal.cancel}
          </div>
          <div
            onClick={() => {
              checkIsNotHaveEmptyField && this.handleSaveBtnClicked()
            }}
            className={`${styles.button} ${
              !checkIsNotHaveEmptyField ? styles.inactive : ''
            }`}
          >
            {I18nLocal.save}
          </div>
        </div>
      </div>
    )
  }

  renderBodyStepSuccess = () => {
    return (
      <div className={styles['success-form']}>
        <div className={styles['title']}>{I18nLocal.success}</div>
        <span>
          <span className={styles.name}>{this.state.temporaryName}</span>{' '}
          {I18nLocal.addCompanySuccessMessage}
        </span>
        <div onClick={this.props.handleClose} className={styles.button}>
          {I18nLocal.done}
        </div>
      </div>
    )
  }

  render() {
    return (
      <Modal
        handleClose={this.props.handleClose}
        isShow={this.props.isShow}
        renderHeader={this.renderHeader}
        renderBody={() => {
          return this.state.step === stepConstants.inputForm
            ? this.renderBodyStepInput()
            : this.renderBodyStepSuccess()
        }}
        afterOpen={this.afterOpen}
        isLoading={this.state.isLoading}
      />
    )
  }
}

export default AddCompanyModal
